import { API_CONFIG, getHeaders } from '../config/settings'

export interface CityCatalogItem {
  id: string
  city: string
  state: string
  location: string
  room_count: number
  priority: number
  hero: {
    label: string
    headline: string
    subtitle: string
    splash_title: string
    region: string
    image: string
  }
}

export interface SearchDefaults {
  city: string
  check_in: string
  check_out: string
  nights: number
  guests_default: number
  booking_pressure: number
  rooms_in_city: number
  availability_hint?: number | null
  reason: string
}

const FALLBACK_CITY: CityCatalogItem = {
  id: 'manauna',
  city: 'Manauna',
  state: 'Uttar Pradesh',
  location: 'Manauna, Uttar Pradesh',
  room_count: 0,
  priority: 100,
  hero: {
    label: 'Manauna Dham',
    headline: 'Manauna Dham',
    subtitle: 'Homestays, BnBs, hotels & yatra services near the mandir',
    splash_title: 'hotels near Manauna Dham',
    region: 'Aonla · Bareilly',
    image: 'manauna-dham/night.webp',
  },
}

/** Local fallback when API unavailable */
export function localDefaultDates(nights = 5): { checkIn: string; checkOut: string } {
  const start = new Date()
  const end = new Date(start)
  end.setDate(end.getDate() + nights)
  const fmt = (d: Date) => d.toISOString().split('T')[0]
  return { checkIn: fmt(start), checkOut: fmt(end) }
}

export async function fetchCityCatalog(): Promise<CityCatalogItem[]> {
  try {
    const res = await fetch(`${API_CONFIG.BASE_URL}/search/cities`, { headers: getHeaders() })
    if (!res.ok) return [FALLBACK_CITY]
    const data = await res.json()
    return data.cities?.length ? data.cities : [FALLBACK_CITY]
  } catch {
    return [FALLBACK_CITY]
  }
}

export async function fetchSearchDefaults(city?: string, nights = 5): Promise<SearchDefaults> {
  const fb = localDefaultDates(nights)
  const fallback: SearchDefaults = {
    city: city || 'Manauna',
    check_in: fb.checkIn,
    check_out: fb.checkOut,
    nights,
    guests_default: 2,
    booking_pressure: 0,
    rooms_in_city: 0,
    reason: 'offline_fallback',
  }
  try {
    const q = new URLSearchParams({ nights: String(nights) })
    if (city) q.set('city', city)
    const res = await fetch(`${API_CONFIG.BASE_URL}/search/defaults?${q}`, { headers: getHeaders() })
    if (!res.ok) return fallback
    return res.json()
  } catch {
    return fallback
  }
}

export { FALLBACK_CITY }
